<template>
  <section v-show="active" class="app-modal__section">
    <header class="app-modal__section-head">
      <h4>{{ saleConfigurationText.header.title }}</h4>
      <p>{{ saleConfigurationText.header.description }}</p>
    </header>

    <div class="app-modal__grid two-columns">
      <div class="app-modal-field">
        <span>{{ saleConfigurationText.fields.seller }}</span>
        <multiselect
          v-model="form.seller"
          :options="options.sellers"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="240"
          :placeholder="saleConfigurationText.placeholders.seller"
          class="app-modal-select"
        >
          <template #noResult>
            <span>{{ salesModalText.common.noOption }}</span>
          </template>
          <template #noOptions>
            <span>{{ salesModalText.common.noOption }}</span>
          </template>
        </multiselect>
      </div>

      <div class="app-modal-field">
        <span>{{ saleConfigurationText.fields.manager }}</span>
        <multiselect
          v-model="form.manager"
          :options="options.managers"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="240"
          :placeholder="saleConfigurationText.placeholders.manager"
          class="app-modal-select"
        >
          <template #noResult>
            <span>{{ salesModalText.common.noOption }}</span>
          </template>
          <template #noOptions>
            <span>{{ salesModalText.common.noOption }}</span>
          </template>
        </multiselect>
      </div>

      <div class="app-modal-field">
        <span>{{ saleConfigurationText.fields.tags }}</span>
        <multiselect
          v-model="form.tags"
          :options="tagOptions"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="160"
          :taggable="true"
          :tag-placeholder="saleConfigurationText.placeholders.tagsAdd"
          :placeholder="saleConfigurationText.placeholders.tags"
          class="app-modal-select sale-tags-select"
          @tag="$emit('add-tag', $event)"
        >
          <template #noResult>
            <span>{{ salesModalText.common.noOption }}</span>
          </template>
          <template #noOptions>
            <span>{{ salesModalText.common.noOption }}</span>
          </template>
        </multiselect>
      </div>

      <div class="app-modal-field">
        <span>{{ saleConfigurationText.fields.status }}</span>
        <multiselect
          v-model="form.status"
          :options="options.statuses"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="160"
          :placeholder="saleConfigurationText.placeholders.status"
          class="app-modal-select"
        >
          <template #noResult>
            <span>{{ salesModalText.common.noOption }}</span>
          </template>
          <template #noOptions>
            <span>{{ salesModalText.common.noOption }}</span>
          </template>
        </multiselect>
      </div>

      <div class="app-modal-field full-width">
        <span>{{ saleConfigurationText.fields.area }}</span>
        <multiselect
          v-model="form.area"
          :options="options.areas"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="120"
          :placeholder="saleConfigurationText.placeholders.area"
          class="app-modal-select"
        >
          <template #noResult>
            <span>{{ salesModalText.common.noOption }}</span>
          </template>
          <template #noOptions>
            <span>{{ salesModalText.common.noOption }}</span>
          </template>
        </multiselect>
      </div>
    </div>
  </section>
</template>

<script>
import { SALES_TEXT } from '@/texts/catalog/sales';

const SALES_MODAL_TEXT = SALES_TEXT.modal;
const SALE_CONFIGURATION_TEXT = SALES_MODAL_TEXT.content.configuration;

export default {
  name: 'SaleModalSectionConfiguration',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    tagOptions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['add-tag'],
  computed: {
    salesModalText() {
      return SALES_MODAL_TEXT;
    },
    saleConfigurationText() {
      return SALE_CONFIGURATION_TEXT;
    },
  },
};
</script>

<style scoped>
.app-modal-select {
  width: 100%;
}

.sale-tags-select :deep(.multiselect__tags),
.sale-tags-select :deep(.multiselect-tags) {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  column-gap: 6px;
  row-gap: 6px;
  min-height: 36px !important;
  height: auto !important;
  padding: 10px 36px 10px 8px !important;
  overflow: hidden;
}

.sale-tags-select :deep(.multiselect__tags-wrap) {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  column-gap: 6px;
  row-gap: 6px;
  width: 100%;
  margin: 0;
  overflow: hidden;
}

.sale-tags-select :deep(.multiselect__input),
.sale-tags-select :deep(.multiselect-input) {
  margin: 0;
  min-height: 24px;
  line-height: 24px;
}

.sale-tags-select :deep(.multiselect__tag),
.sale-tags-select :deep(.multiselect-tag) {
  background: #e9eff8;
  color: #334155;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  line-height: 1;
  min-height: 26px;
  padding: 0 24px 0 10px;
  margin: 0;
}

.sale-tags-select :deep(.multiselect__tag span),
.sale-tags-select :deep(.multiselect-tag span) {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  line-height: 1;
  margin: 0;
}

.sale-tags-select :deep(.multiselect__tag-icon) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 26px;
  top: 0;
  margin: 0;
}

.sale-tags-select :deep(.multiselect__tag-icon:after),
.sale-tags-select :deep(.multiselect-tag-remove) {
  color: #64748b;
  line-height: 1;
  margin: 0;
  transform: none;
}

.sale-tags-select :deep(.multiselect__option--selected),
.sale-tags-select :deep(.multiselect__option--selected.multiselect__option--highlight),
.sale-tags-select :deep(.multiselect-option.is-selected),
.sale-tags-select :deep(.multiselect-option.is-selected.is-pointed) {
  background: #e9eff8;
  color: #334155;
}
</style>
